import '../App.css';
import { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../context/Context';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function Home() {
    // context provided
    const { handleOptions, stripePromise, options, inventory } = useAppContext();

    const navigate = useNavigate();

    //referal checkout
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    return (
        <div className='page' style={{width:'100%', display:'flex', alignItems:'center'}}>
            <img style={{padding:'3px'}} src={'teejeigh.png'} />
            <div style={{maxWidth:'1000px',fontSize:'18px', padding:'10px'}}>Teejeigh LLC is primarily focused on prototype development through both software and hardware innovations. We are a veteran-owned small business located in Michigan, that proudly serves both U.S. government and private-sector clients. If you are interested in working with us to develop your prototype, reach out to <a style={{color:'blue'}} href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a></div>
            <details class="more-projects" style={{maxWidth:'1000px', width:'90%', padding:'13px'}}>
                <summary style={{cursor:'pointer'}}>We have a diverse set of side projects that we have completed over time. Check them out below.</summary>
                <div onClick={()=> navigate('/wbw')} style={{cursor:'pointer', display:'flex', flexDirection:'column', border:'solid gray 1px', margin:'8px', padding:'8px', width:'100%'}}>
                    <div style={{display:'flex', flexDirection:'row', overflowX:'auto', gap: '1rem', padding: '1rem'}}>
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'wbw.jpg'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'blue.png'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'gray.png'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'lightblue.png'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'14.png'} />
                    </div>
                    <div>Wise Band Wallet was a manufacturing project to create a simple wallet made with as little material as possible, while maintaining product quality. Our wallet is made with genuine leather and is available in eight colors.</div>
                </div>

                <div onClick={()=> navigate('/wbw')} style={{cursor:'pointer', display:'flex', flexDirection:'column', border:'solid gray 1px', margin:'8px', padding:'8px', width:'100%'}}>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'center', overflowX:'auto', gap: '1rem', padding: '1rem'}}>
                        <img style={{padding:'3px', maxWidth:'150px', maxHeight:'150px'}} src={'pbbluesq.png'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'pb1.png'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'pb2.png'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'pb3.png'} />
                        <img style={{padding:'3px', maxWidth:'150px'}} src={'pb4.png'} />
                    </div>
                    <div>Paperback is a collection of more than 50,000 public domain books. It allows users to swipe through book cards based on system recommendations or by selecting filter words. Books are available to read directly on the app. The app is available for download on the Google play store.</div>
                </div>
            </details>
        </div>
    )
}

export default Home;